export enum ESubcontractorServiceAreaType {
  // Населенный пункт
  City = 1,
  // Субъект федерации
  Region = 2,
  // Федеральный округ
  FederalDistrict = 3,
}
